import { EmptyStateProps } from './props.js'

export function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    >
      {icon && (
        <div className="text-on-surface-subtle mb-4">
          {icon}
        </div>
      )}
      <h2 className="text-title-md text-on-surface">
        {title}
      </h2>
      {description && (
        <p className="text-body-sm text-on-surface-variant mt-1 max-w-sm">
          {description}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}
